/* eslint-disable @typescript-eslint/camelcase */
import {
  PickupCorporateScheduleConfig,
  PickupScheduleRegularDay,
  PickupScheduleSpecialDate
} from "@/domain/entities/PickupCorporateScheduleConfig";
import { AccountController } from "@/app/ui/controllers/AccountController";

type ApiTimeSlot = { start: string; end: string };
type ApiDay = { day: string; times: ApiTimeSlot[] };
type ApiSpecialDate = { date: string; times: ApiTimeSlot[] };

export class PickupCorporateScheduleConfigApiRequest {
  ps_client_id = 0;
  ps_estimate_total_tonase = 0;
  ps_estimate_total_koli = 0;
  ps_service_codes = "";
  ps_pca_id = 0;
  days: ApiDay[] = [];
  special_dates: ApiSpecialDate[] = [];

  constructor(config: PickupCorporateScheduleConfig) {
    this.ps_client_id =  AccountController.accountData.account_type === "internal" ?
      (
        config.clientId
      ) :
      (
        Number(
        AccountController.accountData.account_type_detail?.id ||
          AccountController.accountData.account_id
        ) || 0
      );
    this.ps_estimate_total_tonase = Number(config.estimateWeight) || 0;
    this.ps_estimate_total_koli = Number(config.estimateAdditionalKoli) || 0;
    this.ps_service_codes = config.serviceCodes.join(",");
    this.ps_pca_id = config.address.pcaId;
    this.days = this.mapDays(config.regularEnabled ? config.regularDays : []);
    this.special_dates = this.mapSpecialDates(
      config.specialEnabled ? config.specialDates : []
    );
  }

  private mapDays(days: PickupScheduleRegularDay[]): ApiDay[] {
    return days
      .filter((day) => day.checked && day.times.length)
      .map((day) => ({
        day: day.day,
        times: day.times.map((time) => ({ start: time.start, end: time.end }))
      }));
  }

  private mapSpecialDates(
    dates: PickupScheduleSpecialDate[]
  ): ApiSpecialDate[] {
    return dates
      .filter((date) => date.times.length)
      .map((date) => ({
        date: date.date,
        times: date.times.map((time) => ({ start: time.start, end: time.end }))
      }));
  }

  toJSON(): Record<string, unknown> {
    return {
      ps_client_id: this.ps_client_id,
      ps_estimate_total_tonase: this.ps_estimate_total_tonase,
      ps_estimate_total_koli: this.ps_estimate_total_koli,
      ps_service_codes: this.ps_service_codes,
      ps_pca_id: this.ps_pca_id,
      days: this.days,
      special_dates: this.special_dates
    };
  }
}

export class PickupCorporateScheduleConfigCreateRequest extends PickupCorporateScheduleConfigApiRequest {}
export class PickupCorporateScheduleConfigUpdateRequest extends PickupCorporateScheduleConfigApiRequest {}
